import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/General-Module-Black.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class GeneralModule extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 100 100' />
  }
}
